<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div (cdkDragEnded)="dragEnded($event)" cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-window-content restorable-window">
    <div cdkDragHandle class="modal-header">
        <h4>Connected Sites</h4>
        <button (click)="closeModal()" matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>

    <div *ngIf="!refresh" class="modal-body">
        <ng-container *ngIf="problematicBUs && problematicBUs.length">
            <h6 (click)="collapseProblematicBUs = !collapseProblematicBUs"
                (keydown)="collapseProblematicBUs = !collapseProblematicBUs"
                class="devices-list-title">
                Problematic BU locations ({{ problematicBUs.length }})
                <button *ngIf="problematicBUs.length" windeActionIcon>
                    <sui-svg-icon [icon]="collapseProblematicBUs ? 'angle-down' : 'angle-up'" windeGrey/>
                </button>
            </h6>

            <ul *ngIf="!collapseProblematicBUs" class="data-list-grid">
                <li *ngFor="let problematicBu of problematicBUs">
                    <winde-problematic-bu-component
                            [problematicBuData]="problematicBu"
                            style="width: 100%"
                    ></winde-problematic-bu-component>
                </li>
            </ul>
        </ng-container>

        <ng-container *ngIf="unconnectedNoLosStations">
            <h6 (click)="collapseNoLOS = !collapseNoLOS"
                (keydown)="collapseNoLOS = !collapseNoLOS"
                class="devices-list-title">
                Unconnected locations, no LOS ({{ unconnectedNoLosStations.length }})
                <button *ngIf="unconnectedNoLosStations.length" windeActionIcon>
                    <sui-svg-icon [icon]="collapseNoLOS ? 'angle-down' : 'angle-up'" windeGrey/>
                </button>
            </h6>
            <ul *ngIf="unconnectedNoLosStations?.length" [ngClass]="{ 'd-none': collapseNoLOS }" class="data-list-grid">
                <li *ngFor="let station of unconnectedNoLosStations">
                    <div>
                        <winde-node-pointer [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                    </div>
                    <div *ngIf="layers" class="node-layer-td">{{ layers[station.layerIndex] }}</div>
                </li>
            </ul>
        </ng-container>

        <ng-container *ngIf="unconnectedNoProdMatchingStations">
            <h6 (click)="collapseNoMatchingProd = !collapseNoMatchingProd"
                (keydown)="collapseNoMatchingProd = !collapseNoMatchingProd"
                class="devices-list-title">
                Unconnected locations, no matching product ({{ unconnectedNoProdMatchingStations.length }})
                <button *ngIf="unconnectedNoProdMatchingStations.length" windeActionIcon>
                    <sui-svg-icon [icon]="collapseNoMatchingProd ? 'angle-down' : 'angle-up'" windeGrey/>
                </button>
            </h6>
            <ul *ngIf="unconnectedNoProdMatchingStations?.length" [ngClass]="{ 'd-none': collapseNoMatchingProd }" class="data-list-grid">
                <li *ngFor="let station of unconnectedNoProdMatchingStations">
                    <div>
                        <winde-node-pointer [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                    </div>
                    <div *ngIf="layers" class="node-layer-td">{{ layers[station.layerIndex] }}</div>
                </li>
            </ul>
        </ng-container>

        <h6 (click)="collapseConn = collapseConn === false"
            (keydown)="collapseConn = collapseConn === false"
            *ngIf="stationConn" class="devices-list-title">
            Connected locations ({{ stationConn.length }})
            <button *ngIf="stationConn.length" windeActionIcon>
                <sui-svg-icon [icon]="collapseConn ? 'angle-down' : 'angle-up'" windeGrey/>
            </button>
        </h6>
        <ul *ngIf="stationConn && stationConn.length" [ngClass]="{ 'd-none': collapseConn }" class="data-list-grid">
            <li *ngFor="let station of stationConn">
                <div>
                    <winde-node-pointer [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                </div>
                <div *ngIf="layers" class="node-layer-td">{{ layers[station.layerIndex] }}</div>
            </li>
        </ul>

        <h6 (click)="collapseDisabled = collapseDisabled === false"
            (keydown)="collapseDisabled = collapseDisabled === false"
            *ngIf="stationDisabled" class="devices-list-title">
            Disabled locations ({{ stationDisabled.length }})
            <button *ngIf="stationDisabled.length" windeActionIcon>
                <sui-svg-icon [icon]="collapseDisabled ? 'angle-down' : 'angle-up'" windeGrey/>
            </button>
        </h6>
        <ul *ngIf="stationDisabled && stationDisabled.length" [ngClass]="{ 'd-none': collapseDisabled }" class="data-list-grid">
            <li *ngFor="let station of stationDisabled">
                <div>
                    <winde-node-pointer [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                </div>
                <div *ngIf="layers" class="node-layer-td">{{ layers[station.layerIndex] }}</div>
            </li>
        </ul>

        <h6 (click)="collapseBuOnly = collapseBuOnly === false"
            (keydown)="collapseBuOnly = collapseBuOnly === false"
            *ngIf="stationBuOnly" class="devices-list-title">
            Optional BU locations ({{ stationBuOnly.length }})
            <button *ngIf="stationBuOnly.length" windeActionIcon>
                <sui-svg-icon [icon]="collapseBuOnly ? 'angle-down' : 'angle-up'" windeGrey/>
            </button>
        </h6>
        <ul *ngIf="stationBuOnly && stationBuOnly.length" [ngClass]="{ 'd-none': collapseBuOnly }" class="data-list-grid">
            <li *ngFor="let station of stationBuOnly">
                <div>
                    <winde-node-pointer [listData]="{ nodeNames: station.nodeid, placement: 'top', cropName: 10 }"></winde-node-pointer>
                </div>
                <div *ngIf="layers" class="node-layer-td">{{ layers[station.layerIndex] }}</div>
            </li>
        </ul>
    </div>
    <div class="modal-footer-button">
        <button (click)="exportToExcel()" [disabled]="disableExportButton" windeGreen>Export to Excel</button>
    </div>
</div>
